import getKfdeMapping from './kfdeMapping';
import getLegacyMapping from './legacyMapping';
import {useNewApi} from './constants.common';
import store from '../checkout/store';


let kfdeMapping = null;
let legacyMapping = null;

export default () => {
  if (useNewApi()) {
    if (kfdeMapping === null) {
      kfdeMapping = getKfdeMapping(store);
    }
    return kfdeMapping;
  }

  if (legacyMapping === null) {
    legacyMapping = getLegacyMapping(store);
  }

  return legacyMapping;
}